import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { AccountGridResponse, Accounts, gridPageRequest, gridPagination } from '../../../model/common/common.model';
import { PaymentTermsGridResponse } from '../../../model/administration.model';
import { AdministratorService } from '../../../services/administrator.service';
import { AccountService } from '../../../services/account.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-glAccount-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './glAccount-lookup.component.html',
  styleUrl: './glAccount-lookup.component.scss'
})
export class GlAccountLookupComponent implements OnInit {
  selectedAccount: Accounts[] = [];
  constructor( private AccountService: AccountService ,private PaymentTermsService: AdministratorService,private ref :DynamicDialogRef )  {
  }

  ngOnInit(): void {
    this.getAccounts(this.pageRequest);
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }

   gridPagination: gridPagination = {
      first: 0,
      last: 0,
      totalRecords: 0
  }

  result: AccountGridResponse = {
     account: [],
     totalRecords: 0
   }

   getAccounts(query: gridPageRequest) {
      this.AccountService.getAllAccounts(query).subscribe({
        next: data => {
          this.result = data as AccountGridResponse;
          this.pageCalculation();
        },
        error: error => {

        }
      });
    }

    pageCalculation() {
      // this.pageRequest.pageSize = this.rowsPerPage;
      let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
      this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
      this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
      this.gridPagination.totalRecords = this.result.totalRecords;
      // this.paginationLabel = _.toString(this.pageRequest.pageIndex * this.pageRequest.pageSize) + (this.result.)
    }

    loadAccounts(event:any){
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getAccounts(this.pageRequest);
    }

   SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }


}
